//screen home generico
//de acuerdo al tipo de usuario, displayar cards de acceso
import { FaRegClock } from "react-icons/fa";
import image1 from "../../assets/images/image1.webp";
import plantHome from "../../assets/icons/plantHome.webp";
import LiveClock from "../../components/ui-elements/LiveClock";
import SelectCardUser from "../../components/SelectCardUser";
import medicineIcon from "../../assets/icons/medicine.webp";
import lab1Icon from "../../assets/icons/lab1.webp";
import blockIcon from "../../assets/icons/block.webp";
import raysIcon from "../../assets/icons/rays.webp";
import intervalsIcon from "../../assets/icons/intervals.webp";
import playIcon from "../../assets/icons/play.webp";
import classesIcon from "../../assets/icons/classes.webp";
import blogIcon from "../../assets/icons/blog.webp";
import boxIcon from "../../assets/icons/box.webp";
import plantPanelIcon from "../../assets/icons/plantPanel.webp";
import usersIcon from "../../assets/icons/users.webp";
import cartIcon from "../../assets/icons/cart.webp";
import bapIcon from "../../assets/icons/bap.webp";

const MainHome = ({ role, name }) => {
  return (
    <div className="flex flex-col justify-center items-center bg-white px-4 py-4 md:px-16 lg:px-16">
      {/* Contenedor principal */}
      <div
        className={`flex ${
          role === "SuperAdmin" ? "flex-col" : "flex-row"
        }flex-col bg-white w-full items-between justify-between max-w-[1200px]`}
      >
        {/* Contenido de bienvenida */}

        {/* Hora y reloj */}
        <div className="w-full flex justify-end flex-col">
          <div className="flex flex-row items-center gap-3 text-dark-green text-[20px] mb-8">
            <FaRegClock className="text-pink-500" />
            <span className="font-poppins text-dark-green">Hora</span>
            <LiveClock />
          </div>

          <div
            className={`flex w-full h-fit  ${
              role === "SuperAdmin"
                ? "flex-row-reverse justify-between"
                : "flex-col"
            }`}
          >
            <img
              src={plantHome}
              alt="plantHome.ico"
              className="h-16 w-16 md:h-20 md:w-20 my-6"
            />

            {/* Textos de bienvenida */}
            <div className="flex flex-col font-poppins gap-4">
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-dark-green">
                ¡Bienvenido, {name}!
              </h1>
              <h1 className="text-lg md:text-xl lg:text-2xl font-bold text-dark-green">
                Organiza tu día con facilidad
              </h1>
              <h1 className="text-base md:text-lg lg:text-xl text-dark-green">
                Accede rápidamente a las secciones que necesitas según tu tarea
                diaria
              </h1>
            </div>
          </div>
        </div>
        {/* Imagen lateral */}
        {role !== "SuperAdmin" && (
          <div className="mt-8 lg:mt-0 pl-10">
            <img
              src={image1}
              alt=""
              className="w-full lg:w-[450px] max-w-[300px] sm:max-w-[450px]"
            />
          </div>
        )}
      </div>

      <div className="flex  w-full my-4 items-center justify-center ">
        <div className="flex flex-wrap max-w-[1280px] w-full items-center justify-center ">
          {/* roles = EcosystemEditor  StoreEditor  SuperAdmin*/}
          {role !== "StoreEditor" && (
            <SelectCardUser
              icon={lab1Icon}
              text={"Registro de laboratorio"}
              link={"/home/registroLaboratorio"}
            />
          )}

          {role === "SuperAdmin" && (
            <SelectCardUser
              icon={plantPanelIcon}
              text={"Panel Detallado"}
              link={"/home/panel"}
            />
          )}

          {role !== "StoreEditor" && (
            <SelectCardUser
              icon={raysIcon}
              text={"Registro de consumo"}
              link={"/home/registroConsumo"}
            />
          )}

          {role != "StoreEditor" && (
            <SelectCardUser
              icon={medicineIcon}
              text={"Lista de medicina"}
              link={"/home/listaMedicina"}
            />
          )}

          {role != "StoreEditor" && (
            <SelectCardUser
              icon={intervalsIcon}
              text={"Temporadas"}
              link={"/home/temporadas"}
            />
          )}

          {role !== "StoreEditor" && (
            <SelectCardUser
              icon={blockIcon}
              text={"Registro de bloques"}
              link={"/home/registroBloques"}
            />
          )}

          {role !== "EcosystemEditor" && (
            <SelectCardUser
              icon={classesIcon}
              text={"Clasificación de productos"}
              link={"/home/productos"}
            />
          )}

          {role !== "EcosystemEditor" && (
            <SelectCardUser
              icon={boxIcon}
              text={"Inventario de productos"}
              link={"/home/inventario"}
            />
          )}

          {role !== "EcosystemEditor" && (
            <SelectCardUser
              icon={cartIcon}
              text={"Compras de clientes"}
              link={"/home/purchases"}
            />
          )}

          {role !== "EcosystemEditor" && (
            <SelectCardUser
              icon={blogIcon}
              text={"Blog de tienda"}
              link={"/home/blogs"}
            />
          )}

          {role !== "EcosystemEditor" && (
            <SelectCardUser
              icon={playIcon}
              text={"Tutoriales"}
              link={"/home/tutoriales"}
            />
          )}

          {role !== "EcosystemEditor" && (
            <SelectCardUser
              icon={bapIcon}
              text={"Banners y Posts"}
              link={"/home/bannersAndPosts"}
            />
          )}

          {role === "SuperAdmin" && (
            <SelectCardUser
              icon={usersIcon}
              text={"Administrar usuarios"}
              link={"/home/users"}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MainHome;
